/* global $$ */
AoPS.EnrollUtils = {
	enrollState: {
		username: null,
		existingStudentPlatformID: null,
		productName: "",
		onUsernameContinue: null,
		enrollModel: null,
		bookOption: null,
		forEbook: false,
		sku: null,
	},

	displayEnroll: function (
		opts = {
			title: "",
			productName: "",
			onUsernameContinue: null,
			enrollModel: null,
			forEbook: false,
			isSelfPaced: false,
			sku: null,
		}
	) {
		// ClassWallet check
		// Weekly Live Classes cannot be purchased through ClassWallet. Self Paced is okay.
		if (
			typeof AoPS.ClassWallet !== "undefined" &&
			AoPS.ClassWallet.checkSessionQuick() &&
			!opts.forEbook &&
			!AoPS.ClassWallet.allowClasswalletForClass(
				parseInt(opts.enrollModel.get("course").is_self_paced)
			)
		) {
			console.log("Not allowed, returning");
			return;
		}
		// End ClassWallet check

		var {enrollNameData, selfLoginId} = this.getExistingLoginIds();
		var hasStudentsOrLoggedIn = enrollNameData || selfLoginId;
		var templateName = hasStudentsOrLoggedIn
			? "enroll-account-prompt-existing-children-tpl"
			: "enroll-account-prompt-tpl";

		// Set up stuff in the state
		if (opts.productName) {
			this.enrollState.productName = opts.productName;
		}
		if (opts.onUsernameContinue) {
			this.enrollState.onUsernameContinue = opts.onUsernameContinue;
		}
		if (opts.enrollModel) {
			this.enrollState.enrollModel = opts.enrollModel;
		}
		if (opts.title) {
			this.enrollState.title = opts.title;
		}
		if (typeof opts.forEbook === "boolean") {
			this.enrollState.forEbook = opts.forEbook;
		}
		if (opts.sku) {
			this.enrollState.sku = opts.sku;
		}

		var templateArgs = {
			name: this.enrollState.productName,
			enrollNameData,
			selfLoginId,
			buttonText: opts.buttonText || "Continue",
			forEbook: this.enrollState.forEbook,
			sku: this.enrollState.sku,
		};

		if ($(".enroll-main").length) {
			this.showTemplate(templateName, templateArgs);
		} else {
			var template = Handlebars.compile($$(templateName).innerHTML);
			this.enrollState.modalEl = AoPS.Ui.Modal.show({
				frame_class: "aops-modal-standard enroll-modal",
				title: opts.title || this.enrollState.title,
				body: `<div class="enroll-main">${template(templateArgs)}</div>`,
				width: "600px",
				max_height: "100%",
				scrollable: true,
			});
		}
		// Set up initially selected/entered values
		if (enrollNameData || selfLoginId) {
			this.setupUsernameSelection(
				enrollNameData && enrollNameData.map((n) => n.username),
				selfLoginId
			);
		} else if (this.enrollState.username) {
			$("input.username").val(this.enrollState.username);
		}

		$(".username-prompt-continue-button").on("click", () => {
			var userData = this.getSelectedUserData();
			AoPS.EnrollUtils.usernameSubmit(userData);
		});

		$(".new-account-button").on("click", () => {
			let mixpanelEventData = {};
			if (this.enrollState.enrollModel) {
				// If the enrollModel exists, we are enrolling in a course
				mixpanelEventData = this.getCourseDataForMixpanel();
			} else {
				// If the enrollModel does not exist, we are enrolling in an ebook
				mixpanelEventData = {
					item_type: "ebook",
					book_id: this.enrollState.sku,
				};
			}

			AoPS.Ui.Modal.removeModal(this.enrollState.modalEl);
			AoPS.Register.display({
				allowLoggedIn: true,
				skipLoadingModal: true,
				replaceModal: true,
				onStep1Continue: (success) => {
					if (window.mixpanel) {
						window.mixpanel.track(
							"AO V0-Checkout Create Account Step 1 Completed",
							{
								...mixpanelEventData,
								success,
							}
						);
					}
				},
				onStep2Continue: ({
					success,
					consented_to_mailing_list,
					is_under_13,
				}) => {
					if (window.mixpanel) {
						window.mixpanel.track(
							"AO V0-Checkout Create Account Step 2 Completed",
							{
								...mixpanelEventData,
								success,
								consented_to_mailing_list,
								is_under_13,
							}
						);
					}
				},
				onSuccess: (username) => {
					this.enrollState.username = username;
					if (this.enrollState.onUsernameContinue) {
						this.enrollState.onUsernameContinue({username});
					} else {
						this.displayBookOptions({
							...this.enrollState.enrollModel.attributes,
							username,
							cost: parseInt(this.enrollState.enrollModel.get("cost")),
						});
					}
				},
				cancel: () => {
					this.displayEnroll();
				},
			});

			if (window.mixpanel) {
				window.mixpanel.track(
					"AO V0-Checkout Create Account Started",
					mixpanelEventData
				);
			}
		});
	},

	/**
	 * Called when submitting username form
	 */
	usernameSubmit: function (userData) {
		this.enrollState.username = userData.username;
		this.enrollState.existingStudentPlatformID =
			userData.existingStudentPlatformID;
		if (this.enrollState.onUsernameContinue) {
			this.enrollState.onUsernameContinue(userData);
		} else {
			var postArgs = {
				action: "user-get",
				username: userData.username,
			};
			if (userData.existingStudentPlatformID) {
				// Go directly to book options if we know this is an existing user
				this.displayBookOptions({
					...this.enrollState.enrollModel.attributes,
					username: userData.username,
					cost: parseInt(this.enrollState.enrollModel.get("cost")),
				});
			} else {
				// Verify username
				$.post("/ajax.php", postArgs, (resp) => {
					if (resp.error_code === "E_NOUSER") {
						this.showError("Username does not exist.");
					} else if (resp.error_msg) {
						this.showError("Invalid username."); // Show default?
					} else {
						this.displayBookOptions({
							...this.enrollState.enrollModel.attributes,
							username: userData.username,
							cost: parseInt(this.enrollState.enrollModel.get("cost")),
						});
					}
				});
			}
		}
	},

	displayBookOptions: function (opts = {}) {
		if ($(".enroll-main").length) {
			var course = this.enrollState.enrollModel.get("course");
			opts.isSelfPaced = false;
			if (course && course.is_self_paced.toString() === "1") {
				opts.isSelfPaced = true;
			}
			this.showTemplate("enroll-textbook-options-tpl", opts);
		} else {
			var template = Handlebars.compile(
				$$("enroll-textbook-options-tpl").innerHTML
			);
			this.enrollState.modalEl = AoPS.Ui.Modal.show({
				frame_class: "aops-modal-standard enroll-modal",
				title: opts.title || this.enrollState.title,
				body: `<div class="enroll-main">${template(opts)}</div>`,
				width: "600px",
				max_height: "100%",
				scrollable: true,
			});
		}

		// Set up initially selected
		var selectedValue = $("input[name=enroll-with]:checked").val();
		if (!selectedValue && this.enrollState.bookOption) {
			$("input[name=enroll-with]")
				.filter('[value="' + this.enrollState.bookOption + '"]')
				.prop("checked", true);
		}

		$(".book-options-back-button").on("click", () => {
			this.displayEnroll();
		});

		$(".book-options-next-button").on("click", () => {
			var bookOption = this.getSelectedBookOption();
			const enrollUtils = this;
			function onResponse(data) {
				if (data.error_msg) {
					// ignore-security-checks
					$("#enrollment-error").show().html(data.error_msg);
				} else {
					var gtm = data.response.gtm;
					AoPS.bd.products = gtm;
					if (gtm[0]) {
						AoPS.bd.value = gtm[0].price;
					}
					AoPS.bd.fireAnalytics = ["add_to_cart"];
					if (AoPS.StoreDatalayer) {
						AoPS.StoreDatalayer.init();
					}
					if (window.mixpanel) {
						window.mixpanel.track("AO Add-to-Cart Button Clicked", {
							items: enrollUtils.getCartItemsForMixpanel(bookOption),
						});
					}
					window.location.href = "/store/checkout";
				}
			}
			this.enrollState.enrollModel.submitEnrollment(
				this.enrollState.username,
				this.enrollState.existingStudentPlatformID || "",
				bookOption,
				onResponse
			);
		});
	},

	showTemplate: function (templateName, templateVars) {
		// Clear out the existing view
		$(".enroll-main").empty();
		var template = Handlebars.compile($$(templateName).innerHTML);
		var bodyEl = template(templateVars);
		$(".enroll-main").append(bodyEl);

		// The timeout may not be needed but it's here to make sure
		// the modal is resized AFTER the template is rendered.
		setTimeout(function () {
			$(window).trigger("resize");
		}, 5);
	},

	getExistingLoginIds: function () {
		var enrollNameData;
		var selfLoginId;
		if (AoPS.bd.childrenData) {
			enrollNameData = AoPS.bd.childrenData.map(function (c) {
				return {username: c.displayed_username, displayName: c.display_name};
			});
		} else if (AoPS.bd.platform_user_info) {
			selfLoginId =
				AoPS.bd.platform_user_info.username || AoPS.bd.platform_user_info.email;
		}
		return {enrollNameData, selfLoginId};
	},

	// Set up event listeners for when radio buttons are clicked for
	// existing usernames.
	setupUsernameSelection: function (enrollUsernames = [], selfLoginId) {
		var alreadySelectedValue = $(
			'input[name="existing-username"]:checked'
		).val();
		var $usernameInput = $("input.username");
		// Set up initially selected
		if (!alreadySelectedValue) {
			if (
				enrollUsernames
					.concat([selfLoginId])
					.includes(this.enrollState.username)
			) {
				$('input[name="existing-username"]')
					.filter('[value="' + this.enrollState.username + '"]')
					.prop("checked", true);
				$usernameInput.prop("disabled", "disabled");
			} else if (this.enrollState.username) {
				$('input[name="existing-username"]')
					.filter('[value="other"]')
					.prop("checked", true);
				$usernameInput.val(this.enrollState.username);
			} else {
				$('input[name="existing-username"]').first().prop("checked", true);
				$usernameInput.prop("disabled", true);
			}
		}

		$('input[name="existing-username"]').on("click", () => {
			var selectedValue = $('input[name="existing-username"]:checked').val();
			if (selectedValue === "other") {
				$usernameInput.prop("disabled", false);
				$usernameInput.focus();
			} else {
				$usernameInput.prop("disabled", true);
			}
			this.hideError();
		});
		$(".existing-student-option.custom").on("click", () => {
			$('input[name="existing-username"]')
				.filter('[value="other"]')
				.prop("checked", true);
			$usernameInput.prop("disabled", false);
			$usernameInput.focus();
		});
	},

	// Get either the selected radio button username or username in input.
	getSelectedUserData: function () {
		var username;
		var existingStudentPlatformID;
		var $selectedRadio = $('input[name="existing-username"]:checked');
		if (
			($selectedRadio && $selectedRadio.val() === "other") ||
			!$selectedRadio.length
		) {
			username = $("input.username").val();
		} else if ($selectedRadio) {
			username = $selectedRadio.val();
		}
		if (AoPS.bd.childrenData) {
			AoPS.bd.childrenData.forEach((c) => {
				if (c.displayed_username === username) {
					existingStudentPlatformID = c.platform_user_id;
				}
			});
		} else if (
			AoPS.bd.platform_user_info &&
			(AoPS.bd.platform_user_info.email === username ||
				AoPS.bd.platform_user_info.username === username)
		) {
			existingStudentPlatformID = AoPS.bd.platform_user_info.platform_user_id;
		}

		return {username, existingStudentPlatformID};
	},

	getSelectedBookOption: function () {
		var selectedValue = $("input[name=enroll-with]:checked").val();
		this.enrollState.bookOption = selectedValue;
		return selectedValue;
	},

	showError: function (msg, $row) {
		if ($row) {
			var $formError = $row.find(".form-error");
			if (!$formError.length) {
				$formError = $('<div class="form-error"></div>').insertAfter(
					$row.find(".form-label")
				);
			}
			// The msg is a string generated on the backend.
			// May contain html like 'contact us' links. It's safe.
			// ignore-security-checks
			$formError.html(msg).show();
		} else {
			$(".modal-error").text(msg);
			$(".modal-error").css({visibility: "visible"});
		}
	},

	hideError: function ($row) {
		if ($row) {
			$row.find(".form-error").hide();
		} else {
			$(".modal-error").text("");
			$(".modal-error").css({visibility: "hidden"});
		}
	},

	getCourseDataForMixpanel: function () {
		if (this.enrollState.enrollModel) {
			const course = this.enrollState.enrollModel.get("course");
			if (course) {
				return {
					item_type: course.is_self_paced === "1" ? "self-paced" : "chat-based",
					class_id: this.enrollState.enrollModel.get("class_id"),
					course_id: course.course_id,
				};
			}
		}
		return {};
	},

	getCartItemsForMixpanel: function (bookOption) {
		const items = [
			{
				...this.getCourseDataForMixpanel(),
				platform_user_id: this.enrollState.existingStudentPlatformID,
				quantity: 1,
			},
		];

		if (bookOption === "both" || bookOption === "physical") {
			for (const sku of this.enrollState.enrollModel.get(
				"physical_book_skus"
			)) {
				items.push({
					book_id: sku,
					item_type: "curriculum",
					quantity: 1,
				});
			}
		}

		if (bookOption === "both" || bookOption === "ebook") {
			items.push({
				platform_user_id: this.enrollState.existingStudentPlatformID,
				book_id: this.enrollState.enrollModel.get("ebook_sku"),
				item_type: "ebook",
				quantity: 1,
			});
		}

		return items;
	},
};
